var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main animated fadeIn faster",class:{ 'expand-main': _vm.isMenuCollapse }},[_c('h3',[_vm._v("Booker Dashboard")]),(_vm.loading)?_c('div'):_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }